import * as React from 'react';
import { Edit, Form, Toolbar } from 'react-admin';
import { matchPath, useLocation } from 'react-router-dom';
import { Box, CardContent } from '@mui/material';
import { GoToListButton } from '../../../components/GoToListButton';
import { OBJECTS_TYPES } from '../../../constants';
import { BuildingAside } from '../BuildingAside';
import { BuildingInputs } from '../BuildingInputs';

export const BuildingEdit = () => {
	const { pathname } = useLocation();
	const match = matchPath(
		{ path: `objects/${OBJECTS_TYPES.BUILDINGS}/edit/:id` },
		pathname
	);

	if (!match) {
		return null;
	}

	const { params } = match;

	return (
		<Box mt={3}>
			<GoToListButton />
			<Edit
				aside={<BuildingAside link="show" />}
				actions={false}
				resource={OBJECTS_TYPES.BUILDINGS}
				redirect={`/objects/${OBJECTS_TYPES.BUILDINGS}/show/${params.id}`}
				transform={values => {
					// add https:// before website if not present
					if (values.website && !values.website.startsWith('http')) {
						values.website = `https://${values.website}`;
					}
					return values;
				}}
			>
				<Form>
					<CardContent sx={{ padding: 0 }}>
						<BuildingInputs />
					</CardContent>
					<Toolbar />
				</Form>
			</Edit>
		</Box>
	);
};
